<template>
  <ArrowNarrowRightIcon class="h-4 w-4 align-middle" />
</template>

<script>
import { ArrowNarrowRightIcon } from '@heroicons/vue/outline'
export default {
  components: {
    ArrowNarrowRightIcon
  }
}
</script>

<style>

</style>
